import { baseStrapiURL } from './config';

export const freebieService = {
    /**
     * Enregistre un utilisateur pour la freebie
     * @param {Object} userData - Données utilisateur
     * @param {string} userData.email
     * @param {string} userData.prenom
     * @param {string} userData.codePostal
     * @param {string} [userData.telephone]
     * @param {string} userData.tag
     * @param {string} userData.slug
     * @param {string} userData.recaptchaToken - Token reCAPTCHA
     * @returns {Promise<Object>} - Réponse de l'API
     */
    async registerForFreebie(userData) {
        try {
            
            const response = await fetch(`${baseStrapiURL}/api/freebie/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: userData.email,
                    prenom: userData.prenom,
                    codePostal: userData.codePostal,
                    telephone: userData.telephone || '',
                    tag:userData.tag,
                    slug:userData.slug,
                    recaptchaToken: userData.recaptchaToken
                })
            });

            const result = await response.json();

            if (!response.ok) {
                console.error('Erreur API freebie:', result);
                throw new Error(result.error?.message || 'Erreur lors de l\'enregistrement');
            }

            return result;
        } catch (error) {
            console.error('Erreur freebie service:', error);
            throw error;
        }
    },
};